import CircularProgress from '@mui/material/CircularProgress';
import CSS from 'csstype';

import "./style.less";

interface ILoader {
	sx?: CSS.Properties;
	msg?: string;
}

export default function Loader({
	sx = {},
	msg = "",
}: ILoader) {
	return <div className="loader" style={ sx }>
		<CircularProgress />
		{ msg && <p className="loader__p">
			{ msg }
		</p> }
	</div>;
}
